

/* eslint-disable no-console */
import traceLog from './TraceLog';
import { AnyObject } from '@/types/generic.types';
import { appConfig } from '@/config/app.config';
import { IAppLogger, LogSeverity } from '@/types/log.types';

export class AppLogger implements IAppLogger {

    trace(message: string, metadata?: any): void {
        if(appConfig.IS_DEV) {
            console.log(`****DEBUG TRACE****: ${message}`, metadata || '');
        }
        traceLog.addLog(message);
    }

    logError(
        error: string | Error,
        severity: LogSeverity = 'error',
        metadata?: AnyObject
    ): void {
        if(appConfig.IS_DEV) {
            console.error(error, metadata);
        }
    }

    logInfo(info: string, metadata?: AnyObject): void {
        if(appConfig.IS_DEV) {
            console.log(`****INFO****: ${info}`, metadata);
        }
    }

    logWarning(warning: string | Error, metadata?: AnyObject): void {
        if(appConfig.IS_DEV) {
            console.warn(warning, metadata);
        }
    }


}

export default new AppLogger();
